module.exports = __webpack_public_path__ + "img/c3.34180145.jpg";